"use strict";

angular.module("customer")
.controller("ConfigurePreAuthorizedPaymentController", function(
    $rootScope, $scope, $state, $stateParams, Language, FlashBag, FormError, gettextCatalog,
    PaymentMethodsService, CustomerPaymentSettingsService,
    PAYMENT_METHODS
) {
    $scope.partnershipTerms = null;
    $scope.selected = {
        bankAccount: null,
        creditCardAccount: null
    };
    $scope.PAYMENT_METHODS = PAYMENT_METHODS;
    $scope.paymentMethodsCount = 0;
    $scope.methodChoicesLocalized = PaymentMethodsService.getMethodChoicesLocalized();
    $scope.partnershipId = $stateParams.id;

    var controller = this;
    var unregister = Language.initializeController(this, "language", null);
    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        controller.language = new_language;
    });

    $scope.$on("$destroy", function() {
        unregisterLanguageChanged();
        unregister();
    });

    fetchPreAuthorizedPaymentTerms();

    $scope.$on("requestResetListing", function() {
        fetchPreAuthorizedPaymentTerms();
    });

    function fetchPreAuthorizedPaymentTerms() {
        CustomerPaymentSettingsService.getPreAuthorizedPaymentTerms($scope.partnershipId)
        .then(function onSuccess(response) {
            if (response.data) {
                $scope.partnershipTerms = response.data;
                $scope.paymentMethodsCount = Object.keys($scope.partnershipTerms.payment_methods).length;
                if ($scope.paymentMethodsCount === 1) {
                    $scope.selectedPaymentMethod = Object.keys($scope.partnershipTerms.payment_methods)[0];
                }
            }
        }, function onError() {
            $scope.partnershipTerms = {};
        });
    }

    this.resetForm = function() {
        $scope.acceptTerms = false;
        if ($scope.configurePreAuthorizedPaymentForm) {
            $scope.configurePreAuthorizedPaymentForm.$setPristine();
        }
    }

    this.configure = function() {
        $scope.configurePreAuthorizedPaymentForm.$setSubmitted();
        FlashBag.clearAll();

        if (!$scope.configurePreAuthorizedPaymentForm.$valid) {
            FormError.focus("configurePreAuthorizedPaymentForm");
            return;
        }

        if ($scope.selectedPaymentMethod === PAYMENT_METHODS.BANK_TRANSFER) {
            $scope.selectedAccount = $scope.selected.bankAccount;
        }
        else if ($scope.selectedPaymentMethod === PAYMENT_METHODS.CREDIT_CARD) {
            $scope.selectedAccount = $scope.selected.creditCardAccount;
        }

        CustomerPaymentSettingsService.acceptPreAuthorizedPaymentTerms(
            $scope.partnershipId,
            $scope.selectedPaymentMethod,
            $scope.selectedAccount
        )
        .then(function onSuccess(response) {
            FlashBag.success(gettextCatalog.getString("You successfully configured your pre-authorized payment."), true);
            if ($stateParams.cart) {
                $state.go("shoppingCart");
            } else {
                $state.go("paymentSettings", {tab: 1});
            }
        }, function onError(response) {
            FlashBag.apiError(response);
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/payment-settings/configure-pre-authorized-payment.controler.js
// module id = 960
// module chunks = 0